if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";
				window.pauseAllMedia();
				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				if (this.loading) return;
				this.loading = true;
				this.productElement = null;
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				const productUrl = opener.getAttribute("data-product-url");

				fetch(productUrl)
					.then((response) => {
						if (!response.ok) throw new Error(`Quick add failed (${response.status})`);
						return response.text();
					})
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						if (!this.productElement) throw new Error("Quick add returned no product form");
						return this.loadReviewsBadgeStyles(responseHTML);
					})
					.then(() => {
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
						this.pointReviewsBadgeAtProduct(productUrl);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						this.syncSourceProductForm(opener);
						this.moveShippingNoticeAboveVariants();
						this.refreshCurrency();
						super.show(opener);
					})
					.catch((error) => {
						console.error(error);
						if (!document.querySelector("quick-add-modal[open]")) {
							document.body.classList.remove("quickview-overflow-hidden", "overflow-hidden");
						}
						const message = document.createElement("span");
						message.className = "visually-hidden";
						message.setAttribute("role", "alert");
						message.textContent = window.cartStrings.error;
						opener.appendChild(message);
						setTimeout(() => message.remove(), 2000);
					})
					.finally(() => {
						this.loading = false;
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						if (this.productElement && typeof window.Swiper === "function") {
							new Swiper(".js-media-list", {
								slidesPerView: 1,
								navigation: {
									nextEl: ".swiper-btn--next",
									prevEl: ".swiper-btn--prev",
								},
							});
						}
					});
			}

			setInnerHTML(element, html) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
				const productTitle = this.modalContent.querySelector(".product__title");
				const customCheck = productTitle && productTitle.textContent.includes("Custom");
              if (customCheck) {
                getCustomDate();
              } else {
                getDate();
              }
			}

			removeDOMElements() {
				const pickupAvailability = this.productElement.querySelector(
					"pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const productModal = this.productElement.querySelector("product-modal");
				if (productModal) productModal.remove();

				const gift = this.productElement.querySelector(".customer");
				if (gift) gift.remove();

				// Quick Add dumps this section's raw HTML into the modal with none
				// of the page's own stylesheets, the collection page this opens
				// from never loads the SIAMKICK customizer's CSS, since that app
				// block only renders on product-template pages, so both the
				// series-colour-swatch row and the customizer entry card rendered
				// completely unstyled here. The Customize button was inert either
				// way: its loader script lives in <head> and was never fetched for
				// this page. Removed before injection, along with the swatch row's
				// sibling fetch script, so quick-add can't also fire that
				// (redundant, catalog-wide) request on every open.
				const seriesSwatches = this.productElement.querySelector(".series-swatches");
				if (seriesSwatches) {
					const swatchScript = seriesSwatches.nextElementSibling;
					if (swatchScript && swatchScript.tagName === "SCRIPT") swatchScript.remove();
					seriesSwatches.remove();
				}

				const customizerEntry = this.productElement.querySelector(".sk-customizer-entry");
				if (customizerEntry) customizerEntry.remove();

				// The same app block also renders a "View customer designs" link
				// beside that card; the owner doesn't want it in quick add.
				const customerDesigns = this.productElement.querySelector(".sk-customizer-entry-designs");
				if (customerDesigns) customerDesigns.remove();
			}

			// The reviews badge is an app block, and Shopify links its stylesheet
			// in the product page's <head>, which quick add never copies. Without
			// it the badge's grey and black star rows sit side by side instead of
			// stacked, and the whole link is underlined. Adopt that <link> from
			// the fetched page, so it follows the app's current release URL, and
			// wait for it so the badge never paints unstyled. Capped so a slow CDN
			// can't hold the modal back.
			loadReviewsBadgeStyles(responseHTML) {
				const selector = 'link[rel="stylesheet"][href*="/siamkick-reviews.css"]';
				const source = responseHTML.querySelector(selector);
				if (!source || !this.productElement.querySelector(".sk-reviews-badge")) {
					return Promise.resolve();
				}

				let link = document.querySelector(selector);
				if (!link) {
					link = document.createElement("link");
					link.rel = "stylesheet";
					link.href = source.getAttribute("href");
					document.head.appendChild(link);
				}
				if (link.sheet || link.dataset.skSettled) return Promise.resolve();

				return new Promise((resolve) => {
					const settle = () => {
						link.dataset.skSettled = "true";
						resolve();
					};
					link.addEventListener("load", settle, { once: true });
					link.addEventListener("error", settle, { once: true });
					setTimeout(resolve, 1500);
				});
			}

			// The badge links to "#sk-reviews", the reviews widget further down
			// the product page. That widget isn't part of the modal, so send the
			// link to this product's own page instead.
			pointReviewsBadgeAtProduct(productUrl) {
				const badge = this.modalContent.querySelector(".sk-reviews-badge");
				if (!badge || !productUrl) return;

				const url = new URL(productUrl, window.location.origin);
				url.hash = "sk-reviews";
				badge.setAttribute("href", url.pathname + url.search + url.hash);
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			syncSourceProductForm(opener) {
				const source = document.getElementById(opener.dataset.sourceProductForm);
				const form = this.modalContent.querySelector('product-form form');
				if (!source || !form) return;

				const quantity = form.querySelector('[name="quantity"]');
				const sourceQuantity = source.querySelector('[name="quantity"]');
				if (quantity && sourceQuantity) quantity.value = sourceQuantity.value;

				const sync = () => {
					const variant = form.querySelector('[name="id"]');
					const sourceVariant = source.querySelector('[name="id"]');
					if (variant && sourceVariant && variant.value !== sourceVariant.value) {
						sourceVariant.value = variant.value;
						sourceVariant.dispatchEvent(new Event('change', { bubbles: true }));
					}
					if (typeof window.skAddonSync === 'function') window.skAddonSync();
					form.querySelectorAll('[data-sticky-source-field]').forEach(field => field.remove());
					for (const [name, value] of new FormData(source)) {
						if (!name.startsWith('properties[') && !name.startsWith('items[') && name !== 'selling_plan') continue;
						if (typeof value !== 'string') continue;
						const existing = Array.from(form.elements).find(field => field.name === name);
						if (existing) {
							existing.value = value;
							continue;
						}
						const field = document.createElement('input');
						field.type = 'hidden';
						field.name = name;
						field.value = value;
						field.dataset.stickySourceField = '';
						form.appendChild(field);
					}
				};
				form.addEventListener('submit', sync, { capture: true });
				sync();
			}

			moveShippingNoticeAboveVariants() {
				// Move the notice itself, not its media-column wrapper, which
				// stretches to fill whatever container it lands in.
				const notice = this.modalContent.querySelector(
					".custom-shipping-container"
				);
				const variants = this.modalContent.querySelector(
					".product-form__input"
				);
				if (!notice || !variants || !variants.parentElement) return;

				const wrapper = notice.closest(".custom-shipping-wrapper");
				variants.parentElement.insertBefore(notice, variants);
				if (wrapper && !wrapper.querySelector(".custom-shipping-container")) {
					wrapper.remove();
				}
			}

			refreshCurrency() {
				if (typeof window.SiamkickCurrencyRefresh !== "function") return;

				window.SiamkickCurrencyRefresh(this.modalContent);
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}
		}
	);
}
function getDate() {
  var daysAfterToday = 2;
  var today = new Date();
  var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
  var options = { weekday: 'short', month: 'long', day: 'numeric' };
  var formattedDate = shipDate.toLocaleDateString(document.documentElement.lang || 'en-US', options);
  const allDates = document.getElementsByClassName("shipping-date");
  for (let i = 0; i < allDates.length; i++) {
    allDates[i].textContent = formattedDate;
  }
}
function getCustomDate() {
  var daysAfterToday = 4;
  var today = new Date();
  var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
  var options = { weekday: 'short', month: 'long', day: 'numeric' };
  var formattedDate = shipDate.toLocaleDateString(document.documentElement.lang || 'en-US', options);
  const allDates = document.getElementsByClassName("custom-shipping-date");
  for (let i = 0; i < allDates.length; i++) {
    allDates[i].textContent = formattedDate;
  }
}
